import React, { FC } from 'react';

import { ZeroState } from '@modernloop/shared/components';
import { SettingsIcon } from '@modernloop/shared/icons';
import { Stack } from '@mui/material';

import { useFeatureFlagString } from 'src/hooks/feature-flag';

interface MaintenancePageProps {
  children: JSX.Element;
}

/**
 * This component is used to show a maintenance page when the user_show_maintenance_screen feature flag is enabled.
 * It blocks all child content and only shows the maintenance page.
 */
const MaintenancePage: FC<MaintenancePageProps> = ({ children }) => {
  const showMaintenancePage = useFeatureFlagString('user_show_maintenance_screen');

  if (showMaintenancePage) {
    return (
      <Stack height="100%" justifyContent="center" alignItems="center" alignContent="center" justifyItems="center">
        <ZeroState icon={<SettingsIcon sx={{ width: '52px', height: '52px' }} />} label={showMaintenancePage} />
      </Stack>
    );
  }

  return children;
};

export default MaintenancePage;
